export class Notfound {
  constructor() {}
}
